
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-[#0A0A0A] text-white">
      {/* Main Footer */}
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-8 lg:px-16 py-12 md:py-16 lg:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12 lg:gap-16">
          {/* Brand Column */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="mb-4 md:mb-6">
              <img
                src="https://static.readdy.ai/image/f38dbee0b97d493b71475a98132a7b29/a415b53a125fde8d120dd58a802f1168.png"
                alt="BuildFast - Nigerian Engineers. German Discipline."
                className="h-10 md:h-12 lg:h-14 w-auto object-contain"
              />
            </div>
            <p className="text-white/50 text-xs md:text-sm leading-relaxed mb-6 md:mb-8">
              Luxury construction finishing and interior furnishing for those who refuse to
              compromise on excellence.
            </p>
            <div className="flex gap-3">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 md:w-10 md:h-10 border border-white/20 flex items-center justify-center hover:border-[#C9A86C] hover:text-[#C9A86C] transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-sm md:text-base" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 md:w-10 md:h-10 border border-white/20 flex items-center justify-center hover:border-[#C9A86C] hover:text-[#C9A86C] transition-all duration-300 cursor-pointer"
              >
                <i className="ri-linkedin-line text-sm md:text-base" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 md:w-10 md:h-10 border border-white/20 flex items-center justify-center hover:border-[#C9A86C] hover:text-[#C9A86C] transition-all duration-300 cursor-pointer"
              >
                <i className="ri-twitter-x-line text-sm md:text-base" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#C9A86C] text-xs md:text-sm tracking-[0.2em] uppercase mb-4 md:mb-6">
              Explore
            </h4>
            <div className="space-y-3 md:space-y-4">
              <Link
                to="/"
                className="block text-white/60 hover:text-[#C9A86C] transition-colors duration-300 cursor-pointer text-sm md:text-base"
              >
                Home
              </Link>
              <Link
                to="/about"
                className="block text-white/60 hover:text-[#C9A86C] transition-colors duration-300 cursor-pointer text-sm md:text-base"
              >
                About Us
              </Link>
              <a
                href="#projects"
                className="block text-white/60 hover:text-[#C9A86C] transition-colors duration-300 cursor-pointer text-sm md:text-base"
              >
                Projects
              </a>
              <a
                href="#services"
                className="block text-white/60 hover:text-[#C9A86C] transition-colors duration-300 cursor-pointer text-sm md:text-base"
              >
                Services
              </a>
              <a
                href="#contact"
                className="block text-white/60 hover:text-[#C9A86C] transition-colors duration-300 cursor-pointer text-sm md:text-base"
              >
                Contact
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[#C9A86C] text-xs md:text-sm tracking-[0.2em] uppercase mb-4 md:mb-6">
              Services
            </h4>
            <div className="space-y-3 md:space-y-4">
              <a
                href="#"
                className="block text-white/60 hover:text-[#C9A86C] transition-colors duration-300 cursor-pointer text-sm md:text-base"
              >
                Construction Finishing
              </a>
              <a
                href="#"
                className="block text-white/60 hover:text-[#C9A86C] transition-colors duration-300 cursor-pointer text-sm md:text-base"
              >
                Interior Furnishing
              </a>
              <a
                href="#"
                className="block text-white/60 hover:text-[#C9A86C] transition-colors duration-300 cursor-pointer text-sm md:text-base"
              >
                Bespoke Detailing
              </a>
              <a
                href="#"
                className="block text-white/60 hover:text-[#C9A86C] transition-colors duration-300 cursor-pointer text-sm md:text-base"
              >
                Project Execution
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#C9A86C] text-xs md:text-sm tracking-[0.2em] uppercase mb-4 md:mb-6">
              Get in Touch
            </h4>
            <div className="space-y-3 md:space-y-4">
              <a
                href="tel:08145540554"
                className="flex items-center gap-2 text-white/60 hover:text-[#C9A86C] transition-colors duration-300 cursor-pointer text-sm md:text-base"
              >
                <i className="ri-phone-line text-[#C9A86C]" />
                08145540554
              </a>
              <a
                href="mailto:hello@buildfast.ng"
                className="flex items-center gap-2 text-white/60 hover:text-[#C9A86C] transition-colors duration-300 cursor-pointer text-sm md:text-base"
              >
                <i className="ri-mail-line text-[#C9A86C]" />
                hello@buildfast.ng
              </a>
              <p className="flex items-start gap-2 text-white/60 text-sm md:text-base">
                <i className="ri-map-pin-line text-[#C9A86C] mt-0.5" />
                Plot 1077, Israel Plaza, Nitel Junction, Wuse 2, Abuja
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-8 lg:px-16 py-4 md:py-6 flex flex-col md:flex-row items-center justify-between gap-3 md:gap-4">
          <p className="text-white/40 text-xs md:text-sm text-center md:text-left">
            © {currentYear} BuildFast. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
            <a
              href="#"
              className="text-white/40 text-xs md:text-sm hover:text-[#C9A86C] transition-colors cursor-pointer"
            >
              Privacy Policy
            </a>
            <a
              href="#"
              className="text-white/40 text-xs md:text-sm hover:text-[#C9A86C] transition-colors cursor-pointer"
            >
              Terms of Service
            </a>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/40 text-xs md:text-sm hover:text-[#C9A86C] transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
